var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 584,
    viewBox: "0 0 1920 584",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M960.012 353.253C960.012 353.253 1303.04 101.349 1919.87 253.899L1920 500C1873.7 455.18 1821.34 420.087 1765.57 392.87C1714.16 367.778 1659.83 349.379 1604.67 336.22C1295.62 262.505 960.012 353.253 960.012 353.253Z",
    fill: "#405985"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0C0 0 317.921 480.754 1284 115.152C637.094 587.197 0 583.999 0 583.999L0 0Z",
    fill: "#D0E2FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactBg);
export default __webpack_public_path__ + "static/media/contact-bg.88e49ab476bbc1dd109caa6c92acb080.svg";
export { ForwardRef as ReactComponent };